import type {
    ToggleFormStatusForAdminResponseType,
    ToggleFormStatusForAdminRequestType
} from "./type";
import {
    request
} from "../request";

const toggleFormStatusForAdmin = async (
    payload: ToggleFormStatusForAdminRequestType
): Promise<ToggleFormStatusForAdminResponseType> => {
    return await request<ToggleFormStatusForAdminResponseType>("/events/toggleFormStatus", {
        body: JSON.stringify(payload),
        method: "POST"
    });
};

export default toggleFormStatusForAdmin;
